module.exports = __webpack_public_path__ + "static/media/map-icon.af98f092.svg";